 <template>
    <div class="analysis-details">  
        <el-form   :label-width="formLabelWidth">
            <el-collapse v-model="collapseName" accordion>
                <el-collapse-item title="图" name="1">
                    <el-form-item label="布局："  prop="storeName" >
                        <el-select    size='mini' v-model="layoutValue"  placeholder="请选择布局">
                            <el-option
                            v-for="item in layoutAll.layoutList"
                            :key="item.label"
                            :label="item.value"
                            :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>  
                </el-collapse-item>
                <el-collapse-item  title="节点" name="2">
                    <el-form-item label="节点距离："  >
                        <el-slider
                            size='small'  :max="50" :min="1"
                            v-model="distanceValue"
                            :disabled="isShowSize"
                            :marks="layoutAll.distanceMarks">
                        </el-slider>
                    </el-form-item>
                    <el-form-item label="节点形状："  prop="storeName" >
                        <el-select  class="analysis-select" size='mini' v-model="shapeValue"  placeholder="请选择节点形状">
                            <el-option
                            v-for="item in layoutAll.shapeList"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="节点大小："    >
                        <el-slider
                            size='small'
                            :max="100"
                            :min="1"
                            v-model="nodeSize"
                            :marks="layoutAll.sizeMarks">
                        </el-slider>
                    </el-form-item>
                    <!-- <el-form-item label="节点度：" prop="storeName" >
                        <div>
                            <el-input type="number"  size='mini' @change="degreeChange" placeholder="请输入内容" v-model="degreeNum"></el-input>
                        </div>
                        <p class="text-tip">*大于或等于该节点都值的节点将被标记为"<span class="icon"></span>"。</p>
                    </el-form-item> -->
                    <el-form-item label="字体大小："   >
                        <el-slider
                            size='small'
                            :max="50"
                            :min="1"
                            v-model="fontSizeValue"
                            :marks="layoutAll.fontSizeMarks">
                        </el-slider>
                    </el-form-item>
                        
                    <el-form-item label="字体位置："    >
                        <el-select size='small' v-model="labelPosition" placeholder="请选择">
                            <el-option size='small'
                                v-for="item in positionOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                        </el-select>  
                    </el-form-item>
                    <el-form-item label="节点颜色："   prop="storeName" >
                        <div class="flex">
                            <el-input  size='mini' placeholder="请输入内容" v-model="pointColor"></el-input>
                            <el-color-picker  size='mini' slot="append" v-model="pointColorValue" @change="pointChange"></el-color-picker>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label="节点过滤：" prop="storeName" >
                        <div class="input-textarea">
                            <el-input  type='textarea'  size='mini' placeholder="请输入内容" v-model="nodeFrom.nodeNames" ></el-input>
                        </div>
                        <p class="text-tip">*输入节点名称以“，”隔开。</p>
                    </el-form-item>  -->
                </el-collapse-item>
                <el-collapse-item title="边" name="3">
                    <el-form-item label="边宽大小："   prop="storeName" >
                        <el-slider
                            size='small'
                            :max="10"
                            :min="1"
                            v-model="sideValue"
                            :marks="layoutAll.sideMarks">
                        </el-slider>
                    </el-form-item>
                    <el-form-item  label="边标签："   prop="storeName" >
                        <el-radio-group v-removeAriaHidden v-model="sideLabel">
                            <el-radio :label="'show'">显示</el-radio>
                            <el-radio :label="'hidden'">隐藏</el-radio>
                        </el-radio-group>
                    </el-form-item>
                        <el-form-item label="边形状："  prop="storeName" >
                        <el-select  class="analysis-select" size='mini' v-model="edgeShapeValue"  placeholder="请选择边形状">
                            <el-option
                            v-for="item in layoutAll.edgeShapeList"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="边样式："  prop="storeName" >
                        <el-select  class="analysis-select" size='mini'  v-model="edgeClassValue"  placeholder="请选择边样式">
                            <el-option
                            v-for="item in layoutAll.edgeClassList"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="边颜色："  prop="storeName" >
                        <div class="flex">
                            <el-input  size='mini' placeholder="请输入内容" v-model="edgeColor"></el-input>
                            <el-color-picker  size='mini' slot="append" v-model="edgeColorValue" @change="edgeChange"></el-color-picker>
                        </div>
                    </el-form-item>
                    <el-form-item label="边权重：" prop="storeName"  >
                        <div>
                            <el-input  size='mini' placeholder="请输入内容" v-model="nodeFrom.minWeight"></el-input>
                        </div>
                        <p class="text-tip">*小于此值的边会被过滤掉。</p>
                    </el-form-item>
                    <el-form-item label="显示边数：" prop="storeName" >
                        <div>
                            <el-input  size='mini' placeholder="请输入内容" v-model="nodeFrom.limitEdgeCount"></el-input>
                        </div>
                        <p class="text-tip">*过滤显示的边的数量。</p>
                    </el-form-item>
                </el-collapse-item> 
            </el-collapse>
                <!-- <el-button type="primary" size="small" @click='getData'>确定</el-button> -->
        </el-form> 
        
        <div class="details-info">  
            <div class="complex-left"> 
                <div id="container" class="complex-d3DIV"></div>
                <div class="complex-list">
                    <el-tabs v-model="activeName" @tab-click="tabClick" type="border-card" >
                        <el-tab-pane name="paneNode"> 
                            <span slot="label"><i class="el-icon-aim"></i> 节点</span>
                            <el-table
                                :data='tableList'
                                @sort-change="sort_change"
                                :header-cell-style="{background:'#409EFF',color:'#fff'}"
                                size='mini'
                                row-key="id"
                                border
                                default-expand-all>
                                <el-table-column
                                    label="NO"
                                    sortable
                                    align="center"
                                    prop="num"
                                >
                                </el-table-column>
                                <el-table-column
                                    sortable
                                    align="center"
                                    prop="name"
                                    label="样本名称">
                                </el-table-column>
                                <el-table-column
                                    sortable
                                    align="center"
                                    prop="degree"
                                    label="节点度">
                                </el-table-column>
                            </el-table>
                            
                        </el-tab-pane>
                        <el-tab-pane name="paneEdge"> 
                            <span slot="label"><i class="el-icon-full-screen"></i> 边</span>
                            <el-table
                                :data='tableList'
                                @sort-change="sort_change"
                                :header-cell-style="{background:'#409EFF',color:'#fff'}"
                                size='mini'
                                row-key="id"
                                border
                                default-expand-all>
                                <el-table-column
                                    sortable
                                    label="NO"
                                    align="center"
                                    prop="num"
                                >
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="source"
                                    sortable
                                    label="节点名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="target"
                                    sortable
                                    label="节点名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="weight"
                                    sortable
                                    label="权重">
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                    <el-pagination 
                        size='small'
                        class="page-wrap"  
                        @current-change="changePage" 
                        @size-change="sizeChange"
                        background
                        :current-page="pageInfo.pageNum" 
                        :page-count="pageInfo.pageTotal" 
                        :page-size="pageInfo.pageSize"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :total="pageInfo.total"
                        layout="total, sizes, prev, pager, next, jumper" >
                    </el-pagination>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
// 模拟数据 
import subjectData from './subjectData.js' 
import subjectJson from './subjectJson.js' 
import modelTip from "../../../components/ui-kit/model_tip.vue"
import G6 from '@antv/g6'; 
// import { complexData_fx } from '../../../io/api.js'
export default {
    components: {
        modelTip, 
    },
    data () {
        return { 
            collapseName:'1',
            queryOption:this.$route.query,//url带过来的参数
            layoutAll:subjectData.layoutAll,
            formLabelWidth:'96px',
            isShowReport:false,
            reportName:'',
            layoutValue:'random',
            distanceValue:30,
            isShowSize:true,//节点距离是否可以调节
            nodeSize:30,
            fontSizeValue:14,
            labelPosition:'center',
            positionOptions:[
                {
                    value: 'center',
                    label: '居中'
                }, {
                    value: 'top',
                    label: '上方'
                },{
                    value: 'left',
                    label: '左边'
                }, {
                    value: 'right',
                    label: '右边'
                }
            ],
            sideValue:1,
            sideLabel:'hidden',
            shapeValue:'circle',
            edgeShapeValue:'line',
            edgeClassValue:'solid',
            isMore:false,
            pointColor:'',
            pointColorValue:'#e64848',
            edgeColor:'',
            edgeColorValue:'#e64848',
            filtrationValue:'',
            reportImg:'',
            reportList:[],
            reportList2:[],
            graph: null,//初始化
            graphWidth:'',
            graphHeight:'',
            newData:[], 
            layerIndex:0,
            layerTab:[],
            graphList:subjectJson.cfyy.zy_fz.jsonList,

            degreeNum:10,
            nodeFrom:{
                minWeight:'10',
                limitEdgeCount:'100',
                layCount:3,//层数  
                sorce:1.3,//置信度
                nodeNames:'',//节点过滤
            },
            tabIndex:0,
            tableListAll:[],
            tableList:[],
            isNodata:false,
            activeName: 'paneNode',
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            initIndex:1

        }
    },
    watch: {
        layoutValue(val,old){ 
            if(val!=old){
                // this.graph.destroy();
                if(val=='mds'||val=='force'){ 
                    this.isShowSize = false
                }else{
                    this.isShowSize = true
                }
                this.layout_tab(val)  
            }
        },
        distanceValue(val,old){ 
            this.distanceStyle(val)
        },

        //边宽大小
        sideValue(val,old){ 
            this.sideStyle(val)
        },
        // 节点大小：
        nodeSize(val,old){ 
            this.nodeSizeStyle(val)
        }, 
        fontSizeValue(val,old){
            this.fontStyle(val);
        },
        labelPosition(val,old){
             this.nodeTextPosition(val)
        },
        edgeClassValue(val,old){
            this.edgeStyle(val);
        },
        edgeShapeValue(val,old){
            this.edgeShapeStyle(val);
        },
        shapeValue(val,old){
            console.log(val,'==shapeValue')
            this.shapeStyle(val);
        },
        sideLabel(val,old){
            this.sideLabelStyle(val);
        },
    },
    mounted () {
        this.getData();
        // this.tabClick()
    },
    methods: { 
        initData(){
            this.sideLabel='hidden';
            this.tabIndex=0;
            this.tableListAll=[];
            this.tableList=[];
            this.distanceValue=30;
            // 
            this.nodeSize=30;
            this.fontSizeValue=14;
            this.sideValue=1;
            this.sideLabel='hidden';
            this.shapeValue='circle';
            this.edgeShapeValue='line';
            this.edgeClassValue='solid';
            this.isMore=false;
            this.pointColor='';
            this.pointColorValue='#e64848';
            this.edgeColor='';
            this.edgeColorValue='#e64848';
            this.activeName='paneNode',
            this.isNodata=false;
            this.pageInfo= {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }; 
        },
        getData(){
            this.initData();
            // let attNa= `${this.queryOption.beforeValue}—${this.queryOption.afterValue}`;
            // let params={
            //     attNa,//
            //     attrNames:this.queryOption.optionLable,
            //     graphType:this.queryOption.graphType||'',//普通关系:0001 层次网络算法:0002 多尺度的backbone网络算法:0003
            //     ...this.nodeFrom
            // }
            // if(params.graphType=='0001'){
            //     params.layCount='';
            //     params.sorce=''
            // }
            this.sideLabel='hidden';
            this.data_process();
            // complexData_fx(params).then(res=>{
            //     let data = res.data;
            //     if(data&&data.code==0){ 
            //         this.graphList = [].concat(data.data.jsonList)  
            //         if(this.graphList.length!=0){
            //             this.data_process();
            //         }else{
            //             this.isNodata = true
            //         }
            //     }else{
            //         this.$message.error(data.msg||'请求失败～')
            //     } 
            // })
        },
        //数据处理
        data_process(){
            //图层级tab
            this.layerTab=[]; 
            this.graphList.forEach((item,index)=>{
                let labelArr=['一','二','三','四','五','六','七','八','九','十']
                let obj={
                    label:'图层'+labelArr[index],
                    num:index
                }
                this.layerTab.push(obj)
            })
            let nodesData=this.graphList &&this.graphList[this.layerIndex].elements.nodes||[];
            let edgesData=this.graphList &&this.graphList[this.layerIndex].elements.edges||[]; 
            if(nodesData.length==0){
                this.isNodata = true
                return
            }
            this.newData={
                nodes:[],
                edges:[],
            }
            nodesData&&nodesData.forEach((item,index)=>{ 
                item.data.label=item.data.name;
                this.$set(item.data,'num',index+1)
                this.newData.nodes.push(item.data)
            }) 
            edgesData&&edgesData.forEach((item,index)=>{

                item.data.label=item.data.weight;
                this.$set(item.data,'num',index+1)
                this.newData.edges.push(item.data)
                
            })  
            this.changePage(1)
            // console.log(this.tabIndex,'=this.tabIndex')
            // this.tabClick(this.tabIndex)
            this.setReportList()
            this.graph_init()

        },
        //图层点击
        layer_click(item){ 
            this.initData();
            this.$nextTick(()=>{ 
                this.layerIndex = item?item.num:0
                this.data_process()
            }) 
        },
        //图谱相关设置
        graph_init(){ 
            let container = document.getElementById('container');
            if (container) {
                this.graphWidth = container.clientWidth;
                this.graphHeight = container.clientHeight;
                this.set_nodeStyle(); 
                this.graph_tab(this.layoutValue,this.sideValue);
            }
        },
        //初始化图谱
        set_nodeStyle(){
            let _this = this;
            //初始化的节点颜色处理 
            this.newData&&this.newData.nodes.forEach(function (node) { 
                if (!node.style) {
                    node.style = {};
                }
                //设置节点颜色
                _this.node_fill(node)
                //根据degree，设置节点大小 
                if(node.degree>Number(_this.degreeNum)){
                    node.size = 40; 
                }else{
                    node.size = 20; 
                }
            });
        },
        //节点的颜色
        node_fill(node,type){
            let color="#F49A3E";
            if(type=='degree'){
                color=this.pointColorValue||"#F49A3E";
            }
            if (node.degree<Number(this.degreeNum)) {
                node.style.fill = color
                node.style.stroke = color
            } else {
                node.style.fill = '#fdcb02'
                node.style.stroke ='#fdcb02'
            }
        },
        //图谱渲染
        graph_tab(val){  
            if (this.graph) this.graph.destroy(); 
            this.graph = new G6.Graph({
                container: 'container',
                width:this.graphWidth,
                height:this.graphHeight, 
                modes: {
                    default: ['zoom-canvas','click-select','drag-canvas', 'drag-node','activate-relations','collapse-expand-combo'],
                },
                layout: {
                    type: val?val:'random',
                    linkDistance:this.distanceValue*10||100,
                }, 
                animate: true,
                //节点在默认状态下的样式属性
                defaultNode: { 
                    size:10,
                    // 节点文字
                    labelCfg: { 
                        position:this.labelPosition,
                        style:{
                            fontSize:14,
                            // stroke:'#000',
                            lineWidth: 2,
                            fill:'#000',
                        }
                    },
                },  
                nodeStateStyles: {
                    // 无关联的节点置灰
                    inactive: {
                        stroke: '#eee',
                        // lineWidth: 2,
                        opacity:.5,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },
                // 设置边高亮样式
                edgeStateStyles: {
                    highlight: {
                        // fill:'#A5E4F0',
                        // stroke: '#A5E4F0', // 这个颜色可以根据个人喜好进行修改
                        lineWidth:8,//lineWidth?lineWidth:4
                        opacity:1
                    },
                    inactive: {
                        stroke: '#eee',
                        fill: "#eee", 
                        'text-shape': {
                            opacity:0.01 
                        },
                    },
                },
                comboStateStyles: {
                    highlight: { 
                        opacity: 0.7,
                        cursor: "pointer",
                        'text-shape': { 
                            lineWidth: 4,
                        },
                    },
                    inactive: {
                        stroke: '#eee',
                        opacity:1,  
                        lineWidth: 4,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },

                //边在默认状态下的样式属性
                defaultEdge: {
                    labelCfg:{
                        style:{
                            opacity:0,
                            fontSize:16,
                            // fill:'#000',
                        }
                    },
                    style:{
                        opacity:.5, 
                        stroke:'#626161',//边的颜色
                        endArrow: { // 设置终点箭头
                            path: '', // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                            stroke:'#626161 ',
                            fill:'#626161 ', 
                        },
                    },
                    
                    // shape: 'arc',  // 在数据中已经指定 shape，这里无需再次指定
                    curveOffset: -80,
                },
            }); 
            this.graph.data(this.newData);
            this.graph.render(); 
            //边的移入移出
            this.graph.on("edge:mouseenter", (e) => {  
                this.graph.setItemState(e.item, "highlight", true);
                this.edgesOpacity(e.item,1,'hover' )   
            });
            this.graph.on("edge:mouseleave", (e) => { 
                this.graph.setItemState(e.item, "highlight", false);
                this.edgesOpacity(e.item,0 ) 
                
            });  
            this.graph.on('node:mouseenter', this.graph_mouseenter)
            this.graph.on('node:mouseleave', this.graph_mouseleave) 
        },
        //更新布局配置项。
        layout_tab(val){
            let graphOption={}
            if(val=='circular'){
                graphOption={
                    radius: 200,
                }
            }else if(val=='force'){
                graphOption={ 
                    preventOverlap: true,
                    nodeSize: 30,
                }
            }else if(val=='concentric'){
                graphOption={ 
                    minNodeSpacing: 30,
                }
            }
            if(val){
                graphOption.type = val;
                graphOption.linkDistance = this.distanceValue*10||100;
                this.graph.updateLayout(graphOption)
            }
            
            if (typeof window !== 'undefined')
            window.onresize = () => {
                if (!this.graph || this.graph.get('destroyed')) return;
                if (!container || !container.scrollWidth || !container.scrollHeight) return;
                this.graph.changeSize(container.scrollWidth, container.scrollHeight - 20);
            };
        },
        
        //鼠标移入时，设置节点连线高亮
        graph_mouseenter(e){
            let that = this // 改变this指向
            let item = e.item; 
            // 设置是否在更新/删除后自动重绘，一般搭配 paint() 方法使用。
            that.graph.setAutoPaint(false) 
            that.graph.getEdges().forEach(function (edge) { 
                //全部边文字显示
                that.edgesOpacity(edge,1 ,'hover' )    
                //getSource()获取当前边的起始节点。 getTarget获取当前边的终止节点。
                if (edge.getSource() != item && edge.getTarget() != item) {
                    that.edgesOpacity(edge,0,'hover')
                } 
            })
            that.graph.paint()
            that.graph.setAutoPaint(true)
        },
        //清除节点连线高亮状态
        graph_mouseleave () {
            const that = this
            this.graph.setAutoPaint(false)
            //边文字不显示
            this.graph.getEdges().forEach(function (edge) { 

                that.edgesOpacity(edge,0,)
            })
 
            this.graph.paint()
            this.graph.setAutoPaint(true)
        },
        //边laberl的文字透明度
        edgesOpacity(edge,num,type){
            let opacity = num;   
            if(this.sideLabel=='show'){
                opacity=0.5;
                if(type=='hover'){
                    opacity=1
                }
            }else{
                opacity=num;
            }
            this.graph.updateItem(edge, {
                labelCfg: {
                    style: {  
                        opacity,
                    }, 
                }
            }) 
        },
        save_pic(){
            window.oldRatio = window.devicePixelRatio
            window.devicePixelRatio = 4
            this.graph.downloadFullImage("复杂网络分析结果图", 'image/png', {padding:20})
            setTimeout(() => {
                window.devicePixelRatio = window.oldRatio
            }, 100) 
        },
        report(){
            // this.isShowReport = true; 
            // console.log(this.reportImg 
            this.graph.toFullDataURL((res)=>{
                this.reportImg= res;

                this.isShowReport = true; 
            }, 'image/png', {padding:20})
        },
        go_back(){
            this.$router.push({
                path:'excavate',
                query:{
                    navType:6,
                }
            }) 
        },
         //列表tab
        tabClick(tab, event) {
            // console.log(tab,'====tabClick')
            this.tabIndex = tab?tab.index:0;
            this.changePage(1)
        },
        /*
            列表及分页table排序======================
        */ 
        setReportList(){
            // 生成报告要用的数组  
            this.reportList=this.reportArr(this.newData.nodes,0);
            this.reportList2=this.reportArr(this.newData.edges,1); 
            
        },
        reportArr(arr,type,){
            let newArr=[]
            arr&&arr.forEach(item=>{
                // console.log(item)
                let obj={}
                if(type==0){
                    obj={
                        keyName:item.name||'',
                        valueName:item.target||'',
                        percentage:item.degree||'',
                    }
                }else if(type==1){
                    obj={
                        keyName:item.source||'',
                        valueName:item.target||'',
                        percentage:item.weight||'',
                    }
                }
                newArr.push(obj)
            })
            return newArr
        },
        changePage(num) { 
            this.pageInfo.pageNum = num;
            if(this.tabIndex==0){
                this.pageInfo.total = this.newData.nodes.length;
                this.tableListAll=this.newData.nodes;
            }else{
                this.pageInfo.total = this.newData.edges.length;
                this.tableListAll=this.newData.edges;
            }
            this.tableList= this.tableListAll.slice((this.pageInfo.pageNum-1)*this.pageInfo.pageSize,this.pageInfo.pageNum*this.pageInfo.pageSize);
        }, 
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column;
            this.pageInfo.total = this.tableListAll.length
            this.tableList = this.tableListAll.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
        sizeChange(val){
            this.pageInfo.pageTotal=Math.ceil(this.pageInfo.total/val),
            this.pageInfo.pageSize=val; 
            this.changePage(1)
        },
        // 是否展开更多
        // more_click(){
        //     this.isMore = !this.isMore;
        // },
        /*
           左侧调整功能========================
        */
        //节点距离
        distanceStyle(val){
            let graphOption={
                type:this.layoutValue,
                linkDistance: val*10||100
            }
            this.graph.updateLayout(graphOption) 
        },
        //节点大小
        nodeSizeStyle(val){
            let _this = this;
            this.newData&&this.newData.nodes.forEach(node=>{ 
                if (!node.style) {
                    node.style = {};
                } 
                node.type = _this.shapeValue; 
                if(_this.shapeValue=='circle'){ 
                    node.size = val
                }else if(_this.shapeValue=='triangle'){ 
                    node.size = [val/2] 
                }if(_this.shapeValue=='rect'|| _this.shapeValue=='diamond'){ 
                    node.size = [val,val] 
                }else if(_this.shapeValue=='ellipse'){
                    node.size = [val,val/2]  
                }else if(_this.shapeValue=='star'){
                    node.size = [val/2,val/2] 
                }
                node.labelCfg.position=this.labelPositions; 
             });
            
            let node = this.graph.getNodes();
            this.refreshItem(node);
            let edges_node = this.graph.getEdges();
            this.refreshItem(edges_node);
        },

        nodeTextPosition(val){
            let _this = this;
            this.newData&&this.newData.nodes.forEach(node=>{ 
                if (!node.style) {
                    node.style = {};
                } 
                node.labelCfg.position=val; 
            });
            let node = this.graph.getNodes();
            this.refreshItem(node);
        },
        //节点形状
        shapeStyle(val){
            let _this = this;
            this.newData&&this.newData.nodes.forEach(node=>{ 
                if (!node.style) {
                    node.style = {};
                } 
                node.type = val;
            });
            this.nodeSizeStyle(this.nodeSize)
        },
        //字体大小
        fontStyle(val){
            //节点label
            this.newData&&this.newData.nodes.forEach(node=>{ 
                node.labelCfg.style.fontSize=val; 
            });
            let node = this.graph.getNodes();
            this.refreshItem(node);
            //边label
            this.newData&&this.newData.edges.forEach(edge=>{ 
                edge.labelCfg.style.fontSize=val ;  
            });
            let edge = this.graph.getEdges();
            this.refreshItem(edge)
        },
        //边宽大小设置
        sideStyle(val){
            let _this = this;
            this.newData&&this.newData.edges.forEach(node=>{ 
                if (!node.style) {
                    node.style = {};
                } 
                node.style.lineWidth=val ;
                node.style.highlight.lineWidth=val; 
            }); 
            let edges_node = this.graph.getEdges();
            this.refreshItem(edges_node);
        },
        //边标签
        sideLabelStyle(val){
            let _this = this;
            let edges_node = this.graph.getEdges();
            if(val=='hidden'){  
                edges_node&&edges_node.forEach(edge => { 
                     _this.edgesOpacity(edge,0)
                });
                
            }else{
                edges_node&&edges_node.forEach(edge => {
                     _this.edgesOpacity(edge,1)
                });
            }
        },
        //节点颜色
        pointChange(val){
            let _this = this;
            this.pointColor = val;
            this.newData&&this.newData.nodes.forEach(node=>{ 
                if (!node.style) {
                    node.style = {};
                }
                if(_this.pointColor!=''){
                    node.style.fill = val;
                    node.style.stroke =  val;
                }
                node.labelCfg.position='center';  
             });

            let node = this.graph.getNodes();
            this.refreshItem(node)
        },
        degreeChange(){
            let _this = this;
            this.newData&&this.newData.nodes.forEach(function (node) { 
                if (!node.style) {
                    node.style = {};
                }
                //设置节点颜色
                _this.node_fill(node,'degree')
             });
            
            let node = this.graph.getNodes(); 

            this.refreshItem(node)




 
            // this.pointChange(color)
            
        },
        //边形状
        edgeShapeStyle(val){
             this.newData&&this.newData.edges.forEach(node=>{ 
                node.type = val;
                if(node.type=='arc'){
                    node.labelCfg.autoRotate=true;
                    node.labelCfg.refY= -10;
                }  
             })
            let edges_node = this.graph.getEdges();
            this.refreshItem(edges_node);
                          
        },
        //边样式
        edgeStyle(val){
            let _this = this;
            this.newData&&this.newData.edges.forEach(node=>{  
                if (!node.style) {
                    node.style = {};
                } 
                if(val=='solid'){
                    node.style.lineDash=[5, 0] ;
                    node.style.highlight.lineDash=[5, 0]; 
                }else if(val=='dashed'){
                    node.style.lineDash=[5, 5] ;
                    node.style.highlight.lineDash=[5, 5]; 
                }else {
                    node.style.lineDash=[2, 2] ;
                    node.style.highlight.lineDash=[2, 2]; 
                }
            })
             let edges_node = this.graph.getEdges();
            this.refreshItem(edges_node);
        },
        //边颜色
        edgeChange(val){
            let _this = this;
            this.edgeColor = val;
            this.newData&&this.newData.edges.forEach(node=>{ 
                if (!node.style) {
                    node.style = {};
                }  
                if(_this.edgeColor!=''){ 
                    node.style.stroke =  val;
                } 
            });
            let edges_node = this.graph.getEdges();
            this.refreshItem(edges_node);
        },
        //刷新节点
        refreshItem(item){
            item.forEach(edge => { 
                edge.refresh();
            });
            this.graph.paint();
        },
    }
}
</script> 
<style lang="less" scoped>
    @import url('./analysis_details.less');
    .text-tip{
        // display: flex;
        .icon{
            display: inline-block;
            vertical-align: middle;
            width:16px;
            height: 16px;
            border-radius: 50%;
            background: #fdcb02;
        }
    } 
.collapse-info{
    ::v-deep .el-form-item{
        padding-right: 20px;
        .el-slider__stop{
            background: #79bbff;
        }
        
    }
    
   
}
#container{
  width: 100%;
  height: 700px;
  margin-bottom: 20px;
}
.layer-tab{
    display: flex;
    .tab{
        border :1px solid #a7754f;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        overflow: hidden;
        display: flex;
    }
    span{
        width: 80px;
        text-align: center;
        line-height: 30px;
        border-right :1px solid #a7754f;
        color: #a7754f;
        cursor: pointer;
        &:last-child{
            border-right :none;
        }
        &.active{
            background-color:#ebdfd7;
            
        }
    }
}
</style>